module.exports = __webpack_public_path__ + "img/male.69ab2450.png";